module.exports = __webpack_public_path__ + "78ec067863caf6b7456df3b353db7548.jpg";